/* eslint-disable default-case */
import store from '@/features/common/store';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import { NotificationData } from '@/features/settings/types';
import { SelectedUnscheduledPickup } from '@/features/schedule-pickup/types';
import { isEnabledPref } from '.';

const checkSchedulePickupForACarrier = (
  selectedShipments: SelectedUnscheduledPickup[],
  carrier: string,
): boolean => {
  if (!selectedShipments.length) return false;

  let isCanpar = false;
  for (let i = 0; i < selectedShipments.length; i += 1) {
    const { carrierCode } = selectedShipments[i];
    if (carrierCode && carrierCode.toLowerCase() === carrier.toLowerCase()) {
      isCanpar = true;
      break;
    }
  }

  return isCanpar;
};

const checkIsResidentialPickup = (
  selectedShipments: SelectedUnscheduledPickup[],
): boolean => {
  if (!selectedShipments.length) return false;

  let isResidential = false;
  for (let i = 0; i < selectedShipments.length; i += 1) {
    const { fromAddress } = selectedShipments[i];
    if (fromAddress && fromAddress.residential) {
      isResidential = true;
      break;
    }
  }

  return isResidential;
};

export const getSchedulePickupNotifications = (
  selectedShipments: SelectedUnscheduledPickup[],
  onSubmit: () => void,
): void => {
  const notificationSettings = store.getters.getNotificationPrefs;
  const notificationData: Array<NotificationData> = [];

  if (isEnabledPref(notificationSettings, 'PickupNotMonitored')) {
    notificationData.push({ name: 'PickupNotMonitored' });
  }

  const isSchedulePickupWithCanpar = checkSchedulePickupForACarrier(
    selectedShipments, 'canpar',
  );
  if (isSchedulePickupWithCanpar
      && isEnabledPref(notificationSettings, 'ScheduleCanparPickup')
  ) {
    notificationData.push({ name: 'ScheduleCanparPickup' });
  }

  const isSchedulePickupWithGLSOrDicom = checkSchedulePickupForACarrier(
    selectedShipments, 'gls',
  );
  if (isSchedulePickupWithGLSOrDicom
      && isEnabledPref(notificationSettings, 'GLSNoPickupFee')
  ) {
    notificationData.push({ name: 'GLSNoPickupFee' });
  }

  const isResidentialPickup = checkIsResidentialPickup(selectedShipments);
  if (isResidentialPickup
      && isEnabledPref(notificationSettings, 'ResidentialPickup')
  ) {
    notificationData.push({ name: 'ResidentialPickup' });
  }

  if (notificationData.length) {
    store.dispatch('showNotification', notificationData);
    eventBus.$once(eventNames.NOTIFICATION_SUBMIT, onSubmit);
  } else {
    onSubmit();
  }
};
